import { useState } from 'react'
import { Button } from '@highlight/ui'
import { twMerge } from 'tailwind-merge'
import { detectedTimeZone, timeZoneOptions, utcOffset } from '../calendar'
import { SetupCallRow, letGoClassName, tactileClassName, titleClassName } from './face'

interface SetupCallTimeZonesProps {
  zone: string
  onSave: (zone: string) => void
  onCancel: () => void
}

export function SetupCallTimeZones({ zone, onSave, onCancel }: SetupCallTimeZonesProps) {
  const [draft, setDraft] = useState(zone)
  const detected = detectedTimeZone()

  return (
    <div className="flex flex-col">
      <SetupCallRow>
        <h2 id="setup-call-zone-title" className={titleClassName}>
          Time zone
        </h2>
      </SetupCallRow>
      <div className="-mx-2 mt-2 flex flex-col" role="radiogroup" aria-labelledby="setup-call-zone-title">
        {timeZoneOptions(detected).map((option) => {
          const isChosen = draft === option.id
          return (
            <SetupCallRow key={option.id}>
              <button
                type="button"
                role="radio"
                aria-checked={isChosen}
                onClick={() => setDraft(option.id)}
                className="hover:bg-element-hover corner-squircle flex min-h-8 w-full items-center gap-2 rounded-2xl px-2 text-left transition-colors"
              >
                <span
                  aria-hidden
                  className={twMerge(
                    'grid size-4 shrink-0 place-items-center rounded-full border-[0.5px] transition-colors',
                    isChosen
                      ? 'border-[oklch(0.624_0.2056_255.5)] bg-[oklch(0.624_0.2056_255.5)]'
                      : 'border-[oklch(1_0_0/0.172)] bg-[oklch(0.178_0_0)]',
                  )}
                >
                  <span
                    className={twMerge(
                      'size-1.5 rounded-full bg-white transition-[scale,opacity]',
                      isChosen ? 'scale-100 opacity-100' : 'scale-0 opacity-0',
                    )}
                  />
                </span>
                <span className="text-foreground min-w-0 flex-1 text-sm font-medium">{option.label}</span>
                <span className="text-foreground-secondary shrink-0 text-xs tabular-nums">
                  {utcOffset(option.id)}
                  {option.id === detected && ' · Detected'}
                </span>
              </button>
            </SetupCallRow>
          )
        })}
      </div>
      <SetupCallRow className="mt-4 flex gap-2">
        <Button size="lg" className={tactileClassName} onClick={() => onSave(draft)}>
          Save
        </Button>
        <Button variant="ghost" tone="on-dark" size="lg" className={letGoClassName} onClick={onCancel}>
          Cancel
        </Button>
      </SetupCallRow>
    </div>
  )
}
